var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[(_vm.icon)?_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.small ? '#fe9a00' : 'black',"size":_vm.small ? 18 : 22}},[_vm._v(" "+_vm._s(`mdi-${_vm.icon}`)+" ")]):_vm._e(),_c('div',{class:['font-weight-bold', _vm.fontSize]},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }